import { render, staticRenderFns } from "./MenuItem.vue?vue&type=template&id=dd860b84&scoped=true&"
import script from "./MenuItem.vue?vue&type=script&lang=ts&"
export * from "./MenuItem.vue?vue&type=script&lang=ts&"
import style0 from "./MenuItem.vue?vue&type=style&index=0&id=dd860b84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd860b84",
  null
  
)

export default component.exports